import { buildLayoutRenderInput } from '@/lib/layouts/buildLayoutRenderInput';
import {
  applyLayoutBinds,
  type LayoutFieldBinds,
} from '@/lib/layouts/layoutFieldBinds';
import { applyMaterializedFillers } from '@/lib/layouts/fillerPlaylist';
import type { PostLayoutConfig } from '@/lib/layouts/types';

export function buildBoundLayoutRenderInput({
  postLayout,
  fieldBinds,
  clipTitle,
  channelName,
  channelAvatarUrl,
  userName,
  userAvatarUrl,
  speakerLayout,
  uniqueSpeakerCount,
  fillerPool,
  clipDurationSec,
  random,
}: {
  postLayout: PostLayoutConfig | null;
  fieldBinds: LayoutFieldBinds;
  clipTitle: string;
  channelName?: string;
  channelAvatarUrl?: string;
  userName?: string;
  userAvatarUrl?: string;
  speakerLayout: number;
  uniqueSpeakerCount: number;
  fillerPool?: string[];
  clipDurationSec?: number;
  random?: () => number;
}) {
  const bound = postLayout
    ? applyLayoutBinds(
      applyMaterializedFillers(postLayout, {
        pool: fillerPool,
        targetDurationSec: clipDurationSec,
        random,
      }),
      fieldBinds,
      {
        clipTitle,
        channelName,
        channelAvatarUrl,
        userName,
        userAvatarUrl,
      },
    )
    : null;
  return buildLayoutRenderInput({
    postLayout: bound,
    speakerLayout,
    uniqueSpeakerCount,
  });
}
